import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { getWithAuth } from 'src/api';
import messages from 'src/messages';
import { useIntl } from 'react-intl';
import SiteBomModal from './SiteBomModal';
import { downloadReport } from 'src/utils/useful_functions';

function NetworkSiteToolbar(props) {
  const { hideButton, graph, siteId, currentSite, projectId } = props;
  const { formatMessage } = useIntl();
  const [installReportLoading, setInstallReportLoading] = useState(false);
  const [salesReportLoading, setSalesReportLoading] = useState(false);

  return (
    <>
      <SiteBomModal
        objId={siteId}
        kind="network_site"
        url={`project/${projectId}/site/${siteId}/bom`}
        disabled={hideButton}
        name={currentSite?.name}
      />
      <Button
        icon
        basic
        compact
        loading={salesReportLoading}
        title={`PMP ${formatMessage(messages.salesReport)}`}
        disabled={graph.aps?.length === 0 || hideButton}
        onClick={() => {
          setSalesReportLoading(true);
          getWithAuth(`project/${projectId}/reports/site/${siteId}/proposal`)
            .then((repId) => {
              downloadReport(
                getWithAuth,
                projectId,
                repId,
                `Site_${currentSite?.name}_PMP_Proposal_Report`
              ).finally(() => {
                setSalesReportLoading(false);
              });
            })
            .catch(() => {
              setSalesReportLoading(false);
            });
        }}
      >
        <Icon className="proposal-report-icon" size="large" />
      </Button>
      <Button
        icon
        basic
        compact
        loading={installReportLoading}
        title={`PMP ${formatMessage(messages.installationReport)}`}
        disabled={graph.aps?.length === 0 || hideButton}
        onClick={() => {
          setInstallReportLoading(true);
          getWithAuth(
            `project/${projectId}/reports/site/${siteId}/installation`
          )
            .then((repId) => {
              downloadReport(
                getWithAuth,
                projectId,
                repId,
                `Site_${currentSite?.name}_PMP_Installation_Report`
              ).finally(() => {
                setInstallReportLoading(false);
              });
            })
            .catch(() => {
              setInstallReportLoading(false);
            });
        }}
      >
        <Icon className="installation-report-icon" size="large" />
      </Button>
    </>
  );
}

export default NetworkSiteToolbar;
